module.exports = __webpack_public_path__ + "media/images/weather/54_day_g-603157166289fb028d39b3bbfd56786f.png";